import * as React from 'react';

import List from '@material-ui/core/List';

export interface ISearchResultListProps {
    items: any[];
    rowRenderer: (item: any, index: number) => JSX.Element;
}

export class SearchResultList extends React.Component<ISearchResultListProps, any> {
    public render() {
        return <List>
        {this.props.items.map(this.props.rowRenderer)}
        </List>;
    }
}


// WEBPACK FOOTER //
// ./src/components/search-result-list.tsx